export default __webpack_public_path__ + "static/media/statistics-icon.392c4672.svg";